module.exports = __webpack_public_path__ + "files/38487675aaf4a5e22a369e17504cf7f5.png";